
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexS_45PFOsPMEMYY8GIHGRS6hUp_45jg2UcOldLLps8hNex50Meta } from "/tmp/build_b3366ff3/pages/app/me/index.vue?macro=true";
import { default as meJ79XoVBmApfcoCpKIOWRni46ZGDtWKQfeNBDjRy6UIgMeta } from "/tmp/build_b3366ff3/pages/app/me.vue?macro=true";
import { default as mapnHAUS3jH06T_9paqVnC6zVdniNMy2KMtpFDeXrHVEE0Meta } from "/tmp/build_b3366ff3/pages/app/map.vue?macro=true";
import { default as postw7OJ4XTWXxqW0cBzZcS57gthWNUGDa98JCxZosa_452j0Meta } from "/tmp/build_b3366ff3/pages/app/feed/post.vue?macro=true";
import { default as indexyVs8TM9svRogVD__yc1b8uOZX0xzM6ui_7TlniNmPZsMeta } from "/tmp/build_b3366ff3/pages/app/feed/index.vue?macro=true";
import { default as _91type_930Lmfzzv_0o2gtjvLhtHtWfOz4WkkTKGaFcb4RaOnPqsMeta } from "/tmp/build_b3366ff3/pages/app/feed/[type].vue?macro=true";
import { default as feedhX7My0toisp_PNexbJtBCxo_45aSGcv05IWRdJGxgTfuEMeta } from "/tmp/build_b3366ff3/pages/app/feed.vue?macro=true";
import { default as index_45OhSmOcoTiZvE8yCQ1lODjLIGTDiWqDjXJNM85XCQL8Meta } from "/tmp/build_b3366ff3/pages/app/index.vue?macro=true";
import { default as eulaxwSwyz3ugxe_efmmX3_45DReF5J1QTE9zhpjFBcGwhf7IMeta } from "/tmp/build_b3366ff3/pages/main/eula.vue?macro=true";
import { default as quiz4tY2dC265JVHNLHeSDs8YSoi8WsZJzStjRRQQg8HdGwMeta } from "/tmp/build_b3366ff3/pages/admin/quiz.vue?macro=true";
import { default as indexUZXp1T_45qUkipcvkAcgUj1XZ95oS7zvOdy5Mb3M_450_dEMeta } from "/tmp/build_b3366ff3/pages/app/groups/index.vue?macro=true";
import { default as editiwn1vqRissNQDwpEt1FvR7_45QHM_WF7rT0rNxTgOxQqEMeta } from "/tmp/build_b3366ff3/pages/app/groups/[slug]/edit.vue?macro=true";
import { default as aboutiY_MrFHSE4weoqu6zW5Z_CN10OV8haV1_wx1CFUsrsEMeta } from "/tmp/build_b3366ff3/pages/app/groups/[slug]/about.vue?macro=true";
import { default as indexi2oIi4Vb1V3fB3yXg957Cjg53xMITCDfU9h7A9GNfXsMeta } from "/tmp/build_b3366ff3/pages/app/groups/[slug]/index.vue?macro=true";
import { default as eventsfp2XpyFmigebvj1AowrYtlZ1SDTJDvjH9eiNFK3G4pUMeta } from "/tmp/build_b3366ff3/pages/app/groups/[slug]/events.vue?macro=true";
import { default as membersfyX3IOCuH_Z5H1M_GcWQavXZMDAJ5d4dbX6Z3Pk1FjUMeta } from "/tmp/build_b3366ff3/pages/app/groups/[slug]/members.vue?macro=true";
import { default as conversationsHQymPtGKP11QuJiRp50khaT2UtAg2Sn_456j6_45LsZFILYMeta } from "/tmp/build_b3366ff3/pages/app/groups/[slug]/conversations.vue?macro=true";
import { default as _91slug_939ylJp0glSBs6Easy46kmAjYU1HK3h0bSfyOZQ4UryEQMeta } from "/tmp/build_b3366ff3/pages/app/groups/[slug].vue?macro=true";
import { default as createNCvGQf_45k_45FdfvZ8q4jy9JTsviK62TdlHIt6DiaoIpO0Meta } from "/tmp/build_b3366ff3/pages/app/groups/create.vue?macro=true";
import { default as groups6yacVkdjXq7fWf5CZu86ELCnbmNt3xhBT6u9yZr60WAMeta } from "/tmp/build_b3366ff3/pages/app/groups.vue?macro=true";
import { default as indexeiXNrXCdKhDAI9G8Xok0qimQcQkjwziYmE4xrBsFmLEMeta } from "/tmp/build_b3366ff3/pages/app/params/index.vue?macro=true";
import { default as accountoYa7TzPtQNh0uGJXDUxYAnhi39srY8zD8fh3aF71f0AMeta } from "/tmp/build_b3366ff3/pages/app/params/account.vue?macro=true";
import { default as transactions9Ruj3gMaRRHrOwc05tDd0g0XA_el73ABB5LO3FVIJeUMeta } from "/tmp/build_b3366ff3/pages/app/params/transactions.vue?macro=true";
import { default as paramsxS4w8uPsSl98cVOcXTZCJM1qCNgiq1OP7n5B7gx8W28Meta } from "/tmp/build_b3366ff3/pages/app/params.vue?macro=true";
import { default as index3glmwUL47pZYDBxGeFVe6z_77FX6iMOI9ZKe4LwYCuMMeta } from "/tmp/build_b3366ff3/pages/main/index.vue?macro=true";
import { default as pressjNXv_45gXFzPeRV5xLk3k7hGfzFj40iu_X8IG6hHY_45OOMMeta } from "/tmp/build_b3366ff3/pages/main/press.vue?macro=true";
import { default as codeskBjQ49B94cARW2pnjhpZXN3aYSwTj9gSP3TXEOmbNYoMeta } from "/tmp/build_b3366ff3/pages/admin/codes.vue?macro=true";
import { default as indexjG3OjBRD2unM8gX9UfZEd_oy_R78vt8PQfDu3JNsk70Meta } from "/tmp/build_b3366ff3/pages/admin/index.vue?macro=true";
import { default as indexGZx4DAshy2SHXRCDizRElWpov2pRQaxUuNZDMIi5susMeta } from "/tmp/build_b3366ff3/pages/app/hangout/index.vue?macro=true";
import { default as agendasi76BypjogF5cekVkBA3PSEe6Mq6qGvM66k9_B0pfugMeta } from "/tmp/build_b3366ff3/pages/app/hangout/agenda.vue?macro=true";
import { default as meetupsRXvbkSk6nwSUexgbnCSXApCy2nXIuFtWJ9HkBPHRWc4Meta } from "/tmp/build_b3366ff3/pages/app/hangout/meetups.vue?macro=true";
import { default as organizeb1q9LDknWbEvkS4SkQRCzdnRS98EpFAO7yPnN2mHM7UMeta } from "/tmp/build_b3366ff3/pages/app/hangout/organize.vue?macro=true";
import { default as hangoutd40h4lzFbpY6WcAqpVQK05TEeCH9uNC7Qj5nGyKqgAgMeta } from "/tmp/build_b3366ff3/pages/app/hangout.vue?macro=true";
import { default as charteMdlFF_45XZsDHdlI3l0esmcGcgUyxAq2kwtw1kH1_45sRnAMeta } from "/tmp/build_b3366ff3/pages/main/charte.vue?macro=true";
import { default as franceQ3XdmVhX0Gj2AmRkfHssg_x6OpwL5hD13DzusSlEC0YMeta } from "/tmp/build_b3366ff3/pages/main/france.vue?macro=true";
import { default as themesycIoDeMmESMhPOqf63smeTj7X5z5XbpfL7_45SVIqQ_ckMeta } from "/tmp/build_b3366ff3/pages/admin/themes.vue?macro=true";
import { default as index19MxoZdlFjwsLAFduTYIV6uY0dwV8SVMdfwsFiG5x0sMeta } from "/tmp/build_b3366ff3/pages/app/insiders/index.vue?macro=true";
import { default as suggestions8_JpxNn6Aj9IvHJdDXxRqR3bDsYDTz6SRrU7ZRZ1kqcMeta } from "/tmp/build_b3366ff3/pages/app/insiders/suggestions.vue?macro=true";
import { default as insidersU__lFAnTGbjJaqIRk_x2Mirl1O7g0zpGaH8Rhuj8IOoMeta } from "/tmp/build_b3366ff3/pages/app/insiders.vue?macro=true";
import { default as messages7OeuEihS2e2uFq36pKEVqjVxlpfUCz3OHkCyxVgKA38Meta } from "/tmp/build_b3366ff3/pages/app/messages.vue?macro=true";
import { default as privacyJTrpMvLesqpcDEYiqNVM29X4xNwQcEQ9xg0cdKd79bkMeta } from "/tmp/build_b3366ff3/pages/main/privacy.vue?macro=true";
import { default as trainerbQjh_45XhO68KjTojYTBTQLVxolC9lFowFsD44ANCeyQ4Meta } from "/tmp/build_b3366ff3/pages/admin/trainer.vue?macro=true";
import { default as indexHPANmqVnX2xjcYY8aCgJ6MLovTyemfuKQSw63mgWh6wMeta } from "/tmp/build_b3366ff3/pages/app/community/index.vue?macro=true";
import { default as searchNrwsrmj_4znsT_sBWkFYAsdjZylBhyyG87wK_45ofgHM8Meta } from "/tmp/build_b3366ff3/pages/app/community/search.vue?macro=true";
import { default as bestiesXabjnhQQnHg76qh28A_45bZeQ50ntBzVBPvEbCY7PoTqQMeta } from "/tmp/build_b3366ff3/pages/app/community/besties.vue?macro=true";
import { default as indexDepi42F81nHygWSUWpIDX0mnaCyP90QrkEZ_Lk98AM0Meta } from "/tmp/build_b3366ff3/pages/app/community/[type]/index.vue?macro=true";
import { default as communityMAr39tmbp1ILBjz7doSNUbreNq_45b51bki1E2_45G89GQkMeta } from "/tmp/build_b3366ff3/pages/app/community.vue?macro=true";
import { default as indexZl6gHb_FoozBoF8TSXBEGXDTAkifPf_45oDzKkeOZb8OEMeta } from "/tmp/build_b3366ff3/pages/app/quiz/[id]/index.vue?macro=true";
import { default as _91id_93hY5Km8EmB7sosxyIHQfjgLryOXBfZtJD3OQbdQ2HgO8Meta } from "/tmp/build_b3366ff3/pages/app/quiz/[id].vue?macro=true";
import { default as indexDpiV434jfibSDJU00kGBLoI8lLWEluX_5q_45bP5S2lS4Meta } from "/tmp/build_b3366ff3/pages/app/auth/index.vue?macro=true";
import { default as aboutyK1vrayxsY_45oUxlWg3_SvDPIJ9GT_45ZK2nfyaPytNxv4Meta } from "/tmp/build_b3366ff3/pages/app/onboarding/about.vue?macro=true";
import { default as emailaRQG7Jpf52ws6UkKeV1vs_uj0frWH5tCdPvcDeLA63UMeta } from "/tmp/build_b3366ff3/pages/app/onboarding/email.vue?macro=true";
import { default as goalsVrXv2HXrLEm72u_45LCGoZjVxYyuS6X7djYhZhLrUjWLcMeta } from "/tmp/build_b3366ff3/pages/app/onboarding/goals.vue?macro=true";
import { default as indexJVUhRvJCgpz2Td6BAjuMmEIJgwXTRUD5WFwOiAW4XwoMeta } from "/tmp/build_b3366ff3/pages/app/onboarding/index.vue?macro=true";
import { default as phoneke_458wyjaw2Whdg8j8FlVH4AbkmMBeRh8klLSeJzH1nMMeta } from "/tmp/build_b3366ff3/pages/app/onboarding/phone.vue?macro=true";
import { default as groupsWzbErtjLv_45NyK0j1I6WCrN8yMbU69LXmuNmf5Myvr90Meta } from "/tmp/build_b3366ff3/pages/app/onboarding/groups.vue?macro=true";
import { default as searchma3dKFUCtufaTPM_o0HUB_BgnVMl7i7LvcXvp_ExxzoMeta } from "/tmp/build_b3366ff3/pages/app/onboarding/search.vue?macro=true";
import { default as charteri_2gq_45_45hN_BYHoa6DZSw83mI8ztY4KsQ8XkDqThNtHcMeta } from "/tmp/build_b3366ff3/pages/app/onboarding/charter.vue?macro=true";
import { default as loading90vZYV7jYyaiVhiK1VSXKscf81uJPIYwzQtfLLrvX9EMeta } from "/tmp/build_b3366ff3/pages/app/onboarding/loading.vue?macro=true";
import { default as profilexBt7437i6YRS41T2Z3FXBGQ_OGe8X1gT6jk8XlqN_r4Meta } from "/tmp/build_b3366ff3/pages/app/onboarding/profile.vue?macro=true";
import { default as identitylu_45GSvJ71bljRWw8Axp3GgSeTaDwiP0NW8KIrhVcxQ0Meta } from "/tmp/build_b3366ff3/pages/app/onboarding/identity.vue?macro=true";
import { default as profilesE7NzNpBENTUDsQsEplTmii6MVJERqQ8Y_45RXOy_Kc444Meta } from "/tmp/build_b3366ff3/pages/app/onboarding/profiles.vue?macro=true";
import { default as membershipGCybeNARoJyX3Q3jRyet_45V8KedR0Ixs25H8Pu_BZ_csMeta } from "/tmp/build_b3366ff3/pages/app/onboarding/membership.vue?macro=true";
import { default as permissionsQoEGXhNEHAfmppPHhIcG_T4XWc3wgZBU_457JI8Quans8Meta } from "/tmp/build_b3366ff3/pages/app/onboarding/permissions.vue?macro=true";
import { default as onboardingndnZd1tBLLCdAHsF57eAbwVX3gA7bul_453O3yiIRn1ZYMeta } from "/tmp/build_b3366ff3/pages/app/onboarding.vue?macro=true";
import { default as indexm13eCzuufqU8KfzGxHXgR1K1mSTSF1FUmH6yH2AvKZoMeta } from "/tmp/build_b3366ff3/pages/app/quiz/index.vue?macro=true";
import { default as investorsemYDTee5oRauC33DWUFNiZKHxci8l_4540igZOKAJ83A4Meta } from "/tmp/build_b3366ff3/pages/main/investors.vue?macro=true";
import { default as _91id_93VxFJqIgM_PtU8co9b5veKO85oTRs5AtoAD1_b_zLQ5MMeta } from "/tmp/build_b3366ff3/pages/admin/blog/[id].vue?macro=true";
import { default as broadcastMx7jKn7Zz2PevLgkrgMlDdhMp_45TRxdoOgpilYkS0bNsMeta } from "/tmp/build_b3366ff3/pages/admin/broadcast.vue?macro=true";
import { default as deleteC5RHQpNIv2B_Dx4t_mT2RLvxIR8sM7rV4z84LgR5qyoMeta } from "/tmp/build_b3366ff3/pages/app/auth/delete.vue?macro=true";
import { default as logoutx8CN9E7_pfHyg3VskZCRIcErMNcmVNMGT5Cr2QvKo0IMeta } from "/tmp/build_b3366ff3/pages/app/auth/logout.vue?macro=true";
import { default as indexIS_45Pyo4vqsnCCA7tkxijtgbcHcLFTXPEKYJQlYhxvZUMeta } from "/tmp/build_b3366ff3/pages/app/story/index.vue?macro=true";
import { default as indexN_45mFOdGvNJ1jy_45ZE2VQMjpboy_YpcFoG1tAB2ITKXFIMeta } from "/tmp/build_b3366ff3/pages/backstage/index.vue?macro=true";
import { default as indexfQw_ppQ1yMPb4EdqlaWUb6ghGZWbTdvIsnvlu1OAb5sMeta } from "/tmp/build_b3366ff3/pages/main/auth/index.vue?macro=true";
import { default as indexSFU0iPvFfWiTwFHB1PPB5BiLnxfreLUAoHtiCjJgCJ4Meta } from "/tmp/build_b3366ff3/pages/main/blog/index.vue?macro=true";
import { default as indexcLV85u5bWKEPuTODWLPG520Sw4DL69UJE030nL9WY4kMeta } from "/tmp/build_b3366ff3/pages/admin/auth/index.vue?macro=true";
import { default as indexy8to0kDhMbflaJNufOasPFnqpSSHayunycaKdKVe5DgMeta } from "/tmp/build_b3366ff3/pages/admin/blog/index.vue?macro=true";
import { default as delete9CCWpRH2mfB6brDUyXa2ZjtQjoKeUvlpRlMvnHLPENsMeta } from "/tmp/build_b3366ff3/pages/main/auth/delete.vue?macro=true";
import { default as _91slug_93Jpf1YrswKQRxmtuLk1g495sC7ZtcIl3fKoy7pVYkYocMeta } from "/tmp/build_b3366ff3/pages/main/blog/[slug].vue?macro=true";
import { default as indexErXH0dTZIFtQN5SHTDmjxPtTJr5k_45FoPNm8vSZg2TWwMeta } from "/tmp/build_b3366ff3/pages/main/event/index.vue?macro=true";
import { default as _91token_93sheFjBhMTotDfBk3HwhVQUCk9gajOCIjpWsOkLQfdJMMeta } from "/tmp/build_b3366ff3/pages/payments/[token].vue?macro=true";
import { default as edites_N_45CPOPcRASPC58tdcQmPuDmPEuOvW5Kv2fY_45zt8kMeta } from "/tmp/build_b3366ff3/pages/app/events/[slug]/edit.vue?macro=true";
import { default as index3xhLynRI6P4bHTPBf20zgQh3g8Nf72H3g9kI3yPnnvwMeta } from "/tmp/build_b3366ff3/pages/app/events/[slug]/index.vue?macro=true";
import { default as _91slug_9391Ym6cgA_NRyFTGhnBtMTndocgauFJ0KqqbJnZcC9Q0Meta } from "/tmp/build_b3366ff3/pages/app/events/[slug].vue?macro=true";
import { default as createJikJSyvsEgB0UlJt4_gFYb4s7BcCpHH5_5SSmthgwgAMeta } from "/tmp/build_b3366ff3/pages/app/events/create.vue?macro=true";
import { default as list_45jaVZx2Sb2MmOPUudxxgIL9PHNrbGA4z_45c5bFW5G_450EMeta } from "/tmp/build_b3366ff3/pages/app/partners/list.vue?macro=true";
import { default as _91slug_932VwuEke39xwFG3ypc0IlT7xAZPgOW69l6tlq9lb6aLgMeta } from "/tmp/build_b3366ff3/pages/main/event/[slug].vue?macro=true";
import { default as _91slug_93VuHu_yJYYI9KTImwrShmtiRjo_45Sq1r_t7U10RaIYlEQMeta } from "/tmp/build_b3366ff3/pages/main/group/[slug].vue?macro=true";
import { default as _91slug_93OBozjRD38bSETGZB4RPg8W3hxcKrjRuAeW307LLjrH4Meta } from "/tmp/build_b3366ff3/pages/main/place/[slug].vue?macro=true";
import { default as _91city_93jTFkJAH_MpFqFK20VIcfTvZuZe6qy9Pb_45X_455D2036VsMeta } from "/tmp/build_b3366ff3/pages/main/cities/[city].vue?macro=true";
import { default as _91slug_93wg4U4Ei4s299lN5xP_cLdJhuuYxEbymsT55mig1s_45HwMeta } from "/tmp/build_b3366ff3/pages/main/invite/[slug].vue?macro=true";
import { default as organizationsE6YRz8nO1doK0Mo_45zm0hahDK_elpARBBY5DtH08bkjoMeta } from "/tmp/build_b3366ff3/pages/admin/organizations.vue?macro=true";
import { default as indexWe9tTo_YcG1Urqw2dBkzT_ejVoD3a391YfXUzXUOv0gMeta } from "/tmp/build_b3366ff3/pages/admin/reports/index.vue?macro=true";
import { default as eventsScUB_45mAWf_455d_45ByWCeUqCvxfiA8x5Wxyphdf6EZSCjgMeta } from "/tmp/build_b3366ff3/pages/admin/reports/events.vue?macro=true";
import { default as preferencesFcR1gTVYJ3RtVo9jEXTCH5EOsA4YcHrl20_45ePoqglOUMeta } from "/tmp/build_b3366ff3/pages/app/auth/preferences.vue?macro=true";
import { default as loginkvvrYWAq4s9wPX_kKu7IPBeraWFQWo4v48nr0DmPyAQMeta } from "/tmp/build_b3366ff3/pages/backstage/auth/login.vue?macro=true";
import { default as _91id_93S5PZ28vp6PBabarKWTiA99Q4dZAFcu4L_45z1sXhYKHWEMeta } from "/tmp/build_b3366ff3/pages/app/conversation/[id].vue?macro=true";
import { default as logoutPd7yidzMUssWzKbZF5RQTGTnEQ5eFFR9ChLP6QEzg5wMeta } from "/tmp/build_b3366ff3/pages/backstage/auth/logout.vue?macro=true";
import { default as preferences8127_DAi_45FZjPKKOdTC1zpI5tPHKzm2Yri5_456eYvXjsMeta } from "/tmp/build_b3366ff3/pages/main/auth/preferences.vue?macro=true";
import { default as listuSdPbZE6N1ZgDbxDHyKRn5cTFEITceQiafFVMYcXIKAMeta } from "/tmp/build_b3366ff3/pages/app/organizations/list.vue?macro=true";
import { default as _91token_9341CvmKqzd2fHSPWdO1U4Jzdrlr148t3YmvZRtJlpQl0Meta } from "/tmp/build_b3366ff3/pages/app/auth/verify/[token].vue?macro=true";
import { default as registersGwN3MJr4UyO_wK9uu8zMpWSy_454IaKdF7McaKOOckYMMeta } from "/tmp/build_b3366ff3/pages/backstage/auth/register.vue?macro=true";
import { default as _91code_93M9_DR2rgZ0gEdLGycALsRvyQaio7_45sNZZ_45p0IXKe0okMeta } from "/tmp/build_b3366ff3/pages/backstage/invite/[code].vue?macro=true";
import { default as discordnJaXDftbSlmj96oIfi_xlqLSMvSMrASzRBVcmSlmZBAMeta } from "/tmp/build_b3366ff3/pages/app/integrations/discord.vue?macro=true";
import { default as indexF1hnQWxDdCfk3QR0sUTQxTAZajpzp8i_45_QuJqqkp2dsMeta } from "/tmp/build_b3366ff3/pages/backstage/dashboard/index.vue?macro=true";
import { default as questions_45frequentesViaFT4mJzwvaYgh4KknABax6citH91yQBtMV3obmt5IMeta } from "/tmp/build_b3366ff3/pages/main/questions-frequentes.vue?macro=true";
import { default as discord_45authsc6hN0mr__45Uu8sn01TgH5WMKcqrlrg7vepJmIrIavOwMeta } from "/tmp/build_b3366ff3/pages/app/integrations/discord-auth.vue?macro=true";
import { default as subscribecWlaoO74hnwhgOJwdkD_45gOgziGUNl1sE3v1MIEAC03MMeta } from "/tmp/build_b3366ff3/pages/backstage/dashboard/subscribe.vue?macro=true";
import { default as indexhAafVUmOcsftiZf9aRFo_I_45iVw1Alm5kH56pAc6rqIoMeta } from "/tmp/build_b3366ff3/pages/backstage/dashboard/events/index.vue?macro=true";
import { default as indexq32UjAZLGgBsIV_QGPzSmpFk6fIEoeNg7UbGCkFeHzMMeta } from "/tmp/build_b3366ff3/pages/backstage/dashboard/places/index.vue?macro=true";
import { default as indexzPO79m90h2niUYVuFBiqmazT639pT2XkiL8eM9TfdH8Meta } from "/tmp/build_b3366ff3/pages/backstage/dashboard/events/[slug]/edit/index.vue?macro=true";
import { default as detailsIigZrnycBfv97ukp5DnQxEzyUSgScgmAVdlynzh85XQMeta } from "/tmp/build_b3366ff3/pages/backstage/dashboard/events/[slug]/edit/details.vue?macro=true";
import { default as advanced6TzWYVqanfcnlVmBQOUHatPEuqNl_45Z7491zN3nxRkkIMeta } from "/tmp/build_b3366ff3/pages/backstage/dashboard/events/[slug]/edit/advanced.vue?macro=true";
import { default as attendeesRXNgYgar15I2lGkrmsEYwD7HuTFHYwqKf1pTACbc5qUMeta } from "/tmp/build_b3366ff3/pages/backstage/dashboard/events/[slug]/edit/attendees.vue?macro=true";
import { default as editODH1ysw4pY5yMHYwJL6zlzOjMICMqkAXomz9SilZsMIMeta } from "/tmp/build_b3366ff3/pages/backstage/dashboard/events/[slug]/edit.vue?macro=true";
import { default as indexMp0kxh5ttS43JhHj0o3VHKjQhV54xkftg6vreudxfUkMeta } from "/tmp/build_b3366ff3/pages/backstage/dashboard/events/[slug]/index.vue?macro=true";
import { default as attendeesKgHLGwdomTTR6wetL9N6Bj9N7u6rPcetJFm_459hp4hccMeta } from "/tmp/build_b3366ff3/pages/backstage/dashboard/events/[slug]/attendees.vue?macro=true";
import { default as _91slug_93vugurFy0nEPl0ZYV0z7WIPZpbmgSXUZzqPy8cgCUbqgMeta } from "/tmp/build_b3366ff3/pages/backstage/dashboard/events/[slug].vue?macro=true";
import { default as createKs6lsHbZRp2Op25_KfVh18ZXPjg_RVfq5Y6wnz5CHmQMeta } from "/tmp/build_b3366ff3/pages/backstage/dashboard/events/create.vue?macro=true";
import { default as index9tZFPNLC4EhlZmlFX16zpI02CjSPibNBC0QUlyUF_3AMeta } from "/tmp/build_b3366ff3/pages/backstage/dashboard/settings/index.vue?macro=true";
import { default as indexSU6XSJfd78Ksr6xB1SQTykEpLSk5iXjA25s3KJc06W8Meta } from "/tmp/build_b3366ff3/pages/backstage/dashboard/organization/index.vue?macro=true";
import { default as component_45stuba1_45WExzWfl1cUO3EeNQED72AZGAhTHwpALY2wQtUwTYMeta } from "/tmp/build_b3366ff3/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stuba1_45WExzWfl1cUO3EeNQED72AZGAhTHwpALY2wQtUwTY } from "/tmp/build_b3366ff3/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: meJ79XoVBmApfcoCpKIOWRni46ZGDtWKQfeNBDjRy6UIgMeta?.name,
    path: "/app/me",
    meta: meJ79XoVBmApfcoCpKIOWRni46ZGDtWKQfeNBDjRy6UIgMeta || {},
    component: () => import("/tmp/build_b3366ff3/pages/app/me.vue"),
    children: [
  {
    name: "app-me",
    path: "",
    component: () => import("/tmp/build_b3366ff3/pages/app/me/index.vue")
  }
]
  },
  {
    name: "app-map",
    path: "/app/map",
    meta: { ...(mapnHAUS3jH06T_9paqVnC6zVdniNMy2KMtpFDeXrHVEE0Meta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_b3366ff3/pages/app/map.vue")
  },
  {
    name: feedhX7My0toisp_PNexbJtBCxo_45aSGcv05IWRdJGxgTfuEMeta?.name,
    path: "/app/feed",
    meta: { ...(feedhX7My0toisp_PNexbJtBCxo_45aSGcv05IWRdJGxgTfuEMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_b3366ff3/pages/app/feed.vue"),
    children: [
  {
    name: "app-feed-post",
    path: "post",
    meta: postw7OJ4XTWXxqW0cBzZcS57gthWNUGDa98JCxZosa_452j0Meta || {},
    component: () => import("/tmp/build_b3366ff3/pages/app/feed/post.vue")
  },
  {
    name: "app-feed",
    path: "",
    meta: indexyVs8TM9svRogVD__yc1b8uOZX0xzM6ui_7TlniNmPZsMeta || {},
    component: () => import("/tmp/build_b3366ff3/pages/app/feed/index.vue")
  },
  {
    name: "app-feed-type",
    path: ":type()",
    meta: _91type_930Lmfzzv_0o2gtjvLhtHtWfOz4WkkTKGaFcb4RaOnPqsMeta || {},
    component: () => import("/tmp/build_b3366ff3/pages/app/feed/[type].vue")
  }
]
  },
  {
    name: "app",
    path: "/app",
    meta: { ...(index_45OhSmOcoTiZvE8yCQ1lODjLIGTDiWqDjXJNM85XCQL8Meta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_b3366ff3/pages/app/index.vue")
  },
  {
    name: "main-eula",
    path: "/main/eula",
    meta: eulaxwSwyz3ugxe_efmmX3_45DReF5J1QTE9zhpjFBcGwhf7IMeta || {},
    component: () => import("/tmp/build_b3366ff3/pages/main/eula.vue")
  },
  {
    name: "admin-quiz",
    path: "/admin/quiz",
    meta: { ...(quiz4tY2dC265JVHNLHeSDs8YSoi8WsZJzStjRRQQg8HdGwMeta || {}), ...{"middleware":["is-admin"]} },
    component: () => import("/tmp/build_b3366ff3/pages/admin/quiz.vue")
  },
  {
    name: groups6yacVkdjXq7fWf5CZu86ELCnbmNt3xhBT6u9yZr60WAMeta?.name,
    path: "/app/groups",
    meta: { ...(groups6yacVkdjXq7fWf5CZu86ELCnbmNt3xhBT6u9yZr60WAMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_b3366ff3/pages/app/groups.vue"),
    children: [
  {
    name: "app-groups",
    path: "",
    component: () => import("/tmp/build_b3366ff3/pages/app/groups/index.vue")
  },
  {
    name: _91slug_939ylJp0glSBs6Easy46kmAjYU1HK3h0bSfyOZQ4UryEQMeta?.name,
    path: ":slug()",
    meta: _91slug_939ylJp0glSBs6Easy46kmAjYU1HK3h0bSfyOZQ4UryEQMeta || {},
    component: () => import("/tmp/build_b3366ff3/pages/app/groups/[slug].vue"),
    children: [
  {
    name: "app-groups-slug-edit",
    path: "edit",
    component: () => import("/tmp/build_b3366ff3/pages/app/groups/[slug]/edit.vue")
  },
  {
    name: "app-groups-slug-about",
    path: "about",
    component: () => import("/tmp/build_b3366ff3/pages/app/groups/[slug]/about.vue")
  },
  {
    name: "app-groups-slug",
    path: "",
    component: () => import("/tmp/build_b3366ff3/pages/app/groups/[slug]/index.vue")
  },
  {
    name: "app-groups-slug-events",
    path: "events",
    component: () => import("/tmp/build_b3366ff3/pages/app/groups/[slug]/events.vue")
  },
  {
    name: "app-groups-slug-members",
    path: "members",
    component: () => import("/tmp/build_b3366ff3/pages/app/groups/[slug]/members.vue")
  },
  {
    name: "app-groups-slug-conversations",
    path: "conversations",
    component: () => import("/tmp/build_b3366ff3/pages/app/groups/[slug]/conversations.vue")
  }
]
  },
  {
    name: "app-groups-create",
    path: "create",
    meta: createNCvGQf_45k_45FdfvZ8q4jy9JTsviK62TdlHIt6DiaoIpO0Meta || {},
    component: () => import("/tmp/build_b3366ff3/pages/app/groups/create.vue")
  }
]
  },
  {
    name: paramsxS4w8uPsSl98cVOcXTZCJM1qCNgiq1OP7n5B7gx8W28Meta?.name,
    path: "/app/params",
    meta: { ...(paramsxS4w8uPsSl98cVOcXTZCJM1qCNgiq1OP7n5B7gx8W28Meta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_b3366ff3/pages/app/params.vue"),
    children: [
  {
    name: "app-params",
    path: "",
    meta: { ...(indexeiXNrXCdKhDAI9G8Xok0qimQcQkjwziYmE4xrBsFmLEMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_b3366ff3/pages/app/params/index.vue")
  },
  {
    name: "app-params-account",
    path: "account",
    meta: { ...(accountoYa7TzPtQNh0uGJXDUxYAnhi39srY8zD8fh3aF71f0AMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_b3366ff3/pages/app/params/account.vue")
  },
  {
    name: "app-params-transactions",
    path: "transactions",
    meta: { ...(transactions9Ruj3gMaRRHrOwc05tDd0g0XA_el73ABB5LO3FVIJeUMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_b3366ff3/pages/app/params/transactions.vue")
  }
]
  },
  {
    name: "main",
    path: "/main",
    meta: index3glmwUL47pZYDBxGeFVe6z_77FX6iMOI9ZKe4LwYCuMMeta || {},
    component: () => import("/tmp/build_b3366ff3/pages/main/index.vue")
  },
  {
    name: "main-press",
    path: "/main/press",
    meta: pressjNXv_45gXFzPeRV5xLk3k7hGfzFj40iu_X8IG6hHY_45OOMMeta || {},
    component: () => import("/tmp/build_b3366ff3/pages/main/press.vue")
  },
  {
    name: "admin-codes",
    path: "/admin/codes",
    meta: { ...(codeskBjQ49B94cARW2pnjhpZXN3aYSwTj9gSP3TXEOmbNYoMeta || {}), ...{"middleware":["is-admin"]} },
    component: () => import("/tmp/build_b3366ff3/pages/admin/codes.vue")
  },
  {
    name: "admin",
    path: "/admin",
    meta: { ...(indexjG3OjBRD2unM8gX9UfZEd_oy_R78vt8PQfDu3JNsk70Meta || {}), ...{"middleware":["is-admin"]} },
    component: () => import("/tmp/build_b3366ff3/pages/admin/index.vue")
  },
  {
    name: hangoutd40h4lzFbpY6WcAqpVQK05TEeCH9uNC7Qj5nGyKqgAgMeta?.name,
    path: "/app/hangout",
    meta: { ...(hangoutd40h4lzFbpY6WcAqpVQK05TEeCH9uNC7Qj5nGyKqgAgMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_b3366ff3/pages/app/hangout.vue"),
    children: [
  {
    name: "app-hangout",
    path: "",
    meta: indexGZx4DAshy2SHXRCDizRElWpov2pRQaxUuNZDMIi5susMeta || {},
    component: () => import("/tmp/build_b3366ff3/pages/app/hangout/index.vue")
  },
  {
    name: "app-hangout-agenda",
    path: "agenda",
    meta: { ...(agendasi76BypjogF5cekVkBA3PSEe6Mq6qGvM66k9_B0pfugMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_b3366ff3/pages/app/hangout/agenda.vue")
  },
  {
    name: "app-hangout-meetups",
    path: "meetups",
    meta: meetupsRXvbkSk6nwSUexgbnCSXApCy2nXIuFtWJ9HkBPHRWc4Meta || {},
    component: () => import("/tmp/build_b3366ff3/pages/app/hangout/meetups.vue")
  },
  {
    name: "app-hangout-organize",
    path: "organize",
    meta: { ...(organizeb1q9LDknWbEvkS4SkQRCzdnRS98EpFAO7yPnN2mHM7UMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_b3366ff3/pages/app/hangout/organize.vue")
  }
]
  },
  {
    name: "main-charte",
    path: "/main/charte",
    meta: charteMdlFF_45XZsDHdlI3l0esmcGcgUyxAq2kwtw1kH1_45sRnAMeta || {},
    component: () => import("/tmp/build_b3366ff3/pages/main/charte.vue")
  },
  {
    name: "main-france",
    path: "/main/france",
    meta: franceQ3XdmVhX0Gj2AmRkfHssg_x6OpwL5hD13DzusSlEC0YMeta || {},
    component: () => import("/tmp/build_b3366ff3/pages/main/france.vue")
  },
  {
    name: "admin-themes",
    path: "/admin/themes",
    meta: { ...(themesycIoDeMmESMhPOqf63smeTj7X5z5XbpfL7_45SVIqQ_ckMeta || {}), ...{"middleware":["is-admin"]} },
    component: () => import("/tmp/build_b3366ff3/pages/admin/themes.vue")
  },
  {
    name: insidersU__lFAnTGbjJaqIRk_x2Mirl1O7g0zpGaH8Rhuj8IOoMeta?.name,
    path: "/app/insiders",
    meta: { ...(insidersU__lFAnTGbjJaqIRk_x2Mirl1O7g0zpGaH8Rhuj8IOoMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_b3366ff3/pages/app/insiders.vue"),
    children: [
  {
    name: "app-insiders",
    path: "",
    component: () => import("/tmp/build_b3366ff3/pages/app/insiders/index.vue")
  },
  {
    name: "app-insiders-suggestions",
    path: "suggestions",
    meta: suggestions8_JpxNn6Aj9IvHJdDXxRqR3bDsYDTz6SRrU7ZRZ1kqcMeta || {},
    component: () => import("/tmp/build_b3366ff3/pages/app/insiders/suggestions.vue")
  }
]
  },
  {
    name: "app-messages",
    path: "/app/messages",
    meta: { ...(messages7OeuEihS2e2uFq36pKEVqjVxlpfUCz3OHkCyxVgKA38Meta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_b3366ff3/pages/app/messages.vue")
  },
  {
    name: "main-privacy",
    path: "/main/privacy",
    meta: privacyJTrpMvLesqpcDEYiqNVM29X4xNwQcEQ9xg0cdKd79bkMeta || {},
    component: () => import("/tmp/build_b3366ff3/pages/main/privacy.vue")
  },
  {
    name: "admin-trainer",
    path: "/admin/trainer",
    meta: { ...(trainerbQjh_45XhO68KjTojYTBTQLVxolC9lFowFsD44ANCeyQ4Meta || {}), ...{"middleware":["is-admin"]} },
    component: () => import("/tmp/build_b3366ff3/pages/admin/trainer.vue")
  },
  {
    name: communityMAr39tmbp1ILBjz7doSNUbreNq_45b51bki1E2_45G89GQkMeta?.name,
    path: "/app/community",
    meta: { ...(communityMAr39tmbp1ILBjz7doSNUbreNq_45b51bki1E2_45G89GQkMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_b3366ff3/pages/app/community.vue"),
    children: [
  {
    name: "app-community",
    path: "",
    meta: indexHPANmqVnX2xjcYY8aCgJ6MLovTyemfuKQSw63mgWh6wMeta || {},
    component: () => import("/tmp/build_b3366ff3/pages/app/community/index.vue")
  },
  {
    name: "app-community-search",
    path: "search",
    meta: searchNrwsrmj_4znsT_sBWkFYAsdjZylBhyyG87wK_45ofgHM8Meta || {},
    component: () => import("/tmp/build_b3366ff3/pages/app/community/search.vue")
  },
  {
    name: "app-community-besties",
    path: "besties",
    component: () => import("/tmp/build_b3366ff3/pages/app/community/besties.vue")
  },
  {
    name: "app-community-type",
    path: ":type()",
    meta: { ...(indexDepi42F81nHygWSUWpIDX0mnaCyP90QrkEZ_Lk98AM0Meta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_b3366ff3/pages/app/community/[type]/index.vue")
  }
]
  },
  {
    name: _91id_93hY5Km8EmB7sosxyIHQfjgLryOXBfZtJD3OQbdQ2HgO8Meta?.name,
    path: "/app/quiz/:id()",
    meta: { ...(_91id_93hY5Km8EmB7sosxyIHQfjgLryOXBfZtJD3OQbdQ2HgO8Meta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_b3366ff3/pages/app/quiz/[id].vue"),
    children: [
  {
    name: "app-quiz-id",
    path: "",
    component: () => import("/tmp/build_b3366ff3/pages/app/quiz/[id]/index.vue")
  }
]
  },
  {
    name: "app-auth",
    path: "/app/auth",
    meta: { ...(indexDpiV434jfibSDJU00kGBLoI8lLWEluX_5q_45bP5S2lS4Meta || {}), ...{"middleware":["is-not-user"]} },
    component: () => import("/tmp/build_b3366ff3/pages/app/auth/index.vue")
  },
  {
    name: onboardingndnZd1tBLLCdAHsF57eAbwVX3gA7bul_453O3yiIRn1ZYMeta?.name,
    path: "/app/onboarding",
    meta: { ...(onboardingndnZd1tBLLCdAHsF57eAbwVX3gA7bul_453O3yiIRn1ZYMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_b3366ff3/pages/app/onboarding.vue"),
    children: [
  {
    name: "app-onboarding-about",
    path: "about",
    component: () => import("/tmp/build_b3366ff3/pages/app/onboarding/about.vue")
  },
  {
    name: "app-onboarding-email",
    path: "email",
    component: () => import("/tmp/build_b3366ff3/pages/app/onboarding/email.vue")
  },
  {
    name: "app-onboarding-goals",
    path: "goals",
    component: () => import("/tmp/build_b3366ff3/pages/app/onboarding/goals.vue")
  },
  {
    name: "app-onboarding",
    path: "",
    meta: indexJVUhRvJCgpz2Td6BAjuMmEIJgwXTRUD5WFwOiAW4XwoMeta || {},
    component: () => import("/tmp/build_b3366ff3/pages/app/onboarding/index.vue")
  },
  {
    name: "app-onboarding-phone",
    path: "phone",
    component: () => import("/tmp/build_b3366ff3/pages/app/onboarding/phone.vue")
  },
  {
    name: "app-onboarding-groups",
    path: "groups",
    component: () => import("/tmp/build_b3366ff3/pages/app/onboarding/groups.vue")
  },
  {
    name: "app-onboarding-search",
    path: "search",
    component: () => import("/tmp/build_b3366ff3/pages/app/onboarding/search.vue")
  },
  {
    name: "app-onboarding-charter",
    path: "charter",
    component: () => import("/tmp/build_b3366ff3/pages/app/onboarding/charter.vue")
  },
  {
    name: "app-onboarding-loading",
    path: "loading",
    component: () => import("/tmp/build_b3366ff3/pages/app/onboarding/loading.vue")
  },
  {
    name: "app-onboarding-profile",
    path: "profile",
    component: () => import("/tmp/build_b3366ff3/pages/app/onboarding/profile.vue")
  },
  {
    name: "app-onboarding-identity",
    path: "identity",
    component: () => import("/tmp/build_b3366ff3/pages/app/onboarding/identity.vue")
  },
  {
    name: "app-onboarding-profiles",
    path: "profiles",
    component: () => import("/tmp/build_b3366ff3/pages/app/onboarding/profiles.vue")
  },
  {
    name: "app-onboarding-membership",
    path: "membership",
    component: () => import("/tmp/build_b3366ff3/pages/app/onboarding/membership.vue")
  },
  {
    name: "app-onboarding-permissions",
    path: "permissions",
    component: () => import("/tmp/build_b3366ff3/pages/app/onboarding/permissions.vue")
  }
]
  },
  {
    name: "app-quiz",
    path: "/app/quiz",
    meta: { ...(indexm13eCzuufqU8KfzGxHXgR1K1mSTSF1FUmH6yH2AvKZoMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_b3366ff3/pages/app/quiz/index.vue")
  },
  {
    name: "main-investors",
    path: "/main/investors",
    meta: investorsemYDTee5oRauC33DWUFNiZKHxci8l_4540igZOKAJ83A4Meta || {},
    component: () => import("/tmp/build_b3366ff3/pages/main/investors.vue")
  },
  {
    name: "admin-blog-id",
    path: "/admin/blog/:id()",
    meta: { ...(_91id_93VxFJqIgM_PtU8co9b5veKO85oTRs5AtoAD1_b_zLQ5MMeta || {}), ...{"middleware":["is-admin"]} },
    component: () => import("/tmp/build_b3366ff3/pages/admin/blog/[id].vue")
  },
  {
    name: "admin-broadcast",
    path: "/admin/broadcast",
    meta: { ...(broadcastMx7jKn7Zz2PevLgkrgMlDdhMp_45TRxdoOgpilYkS0bNsMeta || {}), ...{"middleware":["is-admin"]} },
    component: () => import("/tmp/build_b3366ff3/pages/admin/broadcast.vue")
  },
  {
    name: "app-auth-delete",
    path: "/app/auth/delete",
    meta: deleteC5RHQpNIv2B_Dx4t_mT2RLvxIR8sM7rV4z84LgR5qyoMeta || {},
    component: () => import("/tmp/build_b3366ff3/pages/app/auth/delete.vue")
  },
  {
    name: "app-auth-logout",
    path: "/app/auth/logout",
    meta: logoutx8CN9E7_pfHyg3VskZCRIcErMNcmVNMGT5Cr2QvKo0IMeta || {},
    component: () => import("/tmp/build_b3366ff3/pages/app/auth/logout.vue")
  },
  {
    name: "app-story",
    path: "/app/story",
    meta: { ...(indexIS_45Pyo4vqsnCCA7tkxijtgbcHcLFTXPEKYJQlYhxvZUMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_b3366ff3/pages/app/story/index.vue")
  },
  {
    name: "backstage",
    path: "/backstage",
    meta: { ...(indexN_45mFOdGvNJ1jy_45ZE2VQMjpboy_YpcFoG1tAB2ITKXFIMeta || {}), ...{"middleware":["backstage-auth"]} },
    component: () => import("/tmp/build_b3366ff3/pages/backstage/index.vue")
  },
  {
    name: "main-auth",
    path: "/main/auth",
    component: () => import("/tmp/build_b3366ff3/pages/main/auth/index.vue")
  },
  {
    name: "main-blog",
    path: "/main/blog",
    meta: indexSFU0iPvFfWiTwFHB1PPB5BiLnxfreLUAoHtiCjJgCJ4Meta || {},
    component: () => import("/tmp/build_b3366ff3/pages/main/blog/index.vue")
  },
  {
    name: "admin-auth",
    path: "/admin/auth",
    meta: indexcLV85u5bWKEPuTODWLPG520Sw4DL69UJE030nL9WY4kMeta || {},
    component: () => import("/tmp/build_b3366ff3/pages/admin/auth/index.vue")
  },
  {
    name: "admin-blog",
    path: "/admin/blog",
    meta: { ...(indexy8to0kDhMbflaJNufOasPFnqpSSHayunycaKdKVe5DgMeta || {}), ...{"middleware":["is-admin"]} },
    component: () => import("/tmp/build_b3366ff3/pages/admin/blog/index.vue")
  },
  {
    name: "main-auth-delete",
    path: "/main/auth/delete",
    component: () => import("/tmp/build_b3366ff3/pages/main/auth/delete.vue")
  },
  {
    name: "main-blog-slug",
    path: "/main/blog/:slug()",
    meta: _91slug_93Jpf1YrswKQRxmtuLk1g495sC7ZtcIl3fKoy7pVYkYocMeta || {},
    component: () => import("/tmp/build_b3366ff3/pages/main/blog/[slug].vue")
  },
  {
    name: "main-event",
    path: "/main/event",
    meta: indexErXH0dTZIFtQN5SHTDmjxPtTJr5k_45FoPNm8vSZg2TWwMeta || {},
    component: () => import("/tmp/build_b3366ff3/pages/main/event/index.vue")
  },
  {
    name: "payments-token",
    path: "/payments/:token()",
    meta: _91token_93sheFjBhMTotDfBk3HwhVQUCk9gajOCIjpWsOkLQfdJMMeta || {},
    component: () => import("/tmp/build_b3366ff3/pages/payments/[token].vue")
  },
  {
    name: _91slug_9391Ym6cgA_NRyFTGhnBtMTndocgauFJ0KqqbJnZcC9Q0Meta?.name,
    path: "/app/events/:slug()",
    meta: { ...(_91slug_9391Ym6cgA_NRyFTGhnBtMTndocgauFJ0KqqbJnZcC9Q0Meta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_b3366ff3/pages/app/events/[slug].vue"),
    children: [
  {
    name: "app-events-slug-edit",
    path: "edit",
    meta: edites_N_45CPOPcRASPC58tdcQmPuDmPEuOvW5Kv2fY_45zt8kMeta || {},
    component: () => import("/tmp/build_b3366ff3/pages/app/events/[slug]/edit.vue")
  },
  {
    name: "app-events-slug",
    path: "",
    component: () => import("/tmp/build_b3366ff3/pages/app/events/[slug]/index.vue")
  }
]
  },
  {
    name: "app-events-create",
    path: "/app/events/create",
    meta: { ...(createJikJSyvsEgB0UlJt4_gFYb4s7BcCpHH5_5SSmthgwgAMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_b3366ff3/pages/app/events/create.vue")
  },
  {
    name: "app-partners-list",
    path: "/app/partners/list",
    meta: { ...(list_45jaVZx2Sb2MmOPUudxxgIL9PHNrbGA4z_45c5bFW5G_450EMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_b3366ff3/pages/app/partners/list.vue")
  },
  {
    name: "main-event-slug",
    path: "/main/event/:slug()",
    meta: _91slug_932VwuEke39xwFG3ypc0IlT7xAZPgOW69l6tlq9lb6aLgMeta || {},
    component: () => import("/tmp/build_b3366ff3/pages/main/event/[slug].vue")
  },
  {
    name: "main-group-slug",
    path: "/main/group/:slug()",
    meta: _91slug_93VuHu_yJYYI9KTImwrShmtiRjo_45Sq1r_t7U10RaIYlEQMeta || {},
    component: () => import("/tmp/build_b3366ff3/pages/main/group/[slug].vue")
  },
  {
    name: "main-place-slug",
    path: "/main/place/:slug()",
    meta: _91slug_93OBozjRD38bSETGZB4RPg8W3hxcKrjRuAeW307LLjrH4Meta || {},
    component: () => import("/tmp/build_b3366ff3/pages/main/place/[slug].vue")
  },
  {
    name: "main-cities-city",
    path: "/main/cities/:city()",
    meta: _91city_93jTFkJAH_MpFqFK20VIcfTvZuZe6qy9Pb_45X_455D2036VsMeta || {},
    component: () => import("/tmp/build_b3366ff3/pages/main/cities/[city].vue")
  },
  {
    name: "main-invite-slug",
    path: "/main/invite/:slug()",
    component: () => import("/tmp/build_b3366ff3/pages/main/invite/[slug].vue")
  },
  {
    name: "admin-organizations",
    path: "/admin/organizations",
    meta: { ...(organizationsE6YRz8nO1doK0Mo_45zm0hahDK_elpARBBY5DtH08bkjoMeta || {}), ...{"middleware":["is-admin"]} },
    component: () => import("/tmp/build_b3366ff3/pages/admin/organizations.vue")
  },
  {
    name: "admin-reports",
    path: "/admin/reports",
    meta: { ...(indexWe9tTo_YcG1Urqw2dBkzT_ejVoD3a391YfXUzXUOv0gMeta || {}), ...{"middleware":["is-admin"]} },
    component: () => import("/tmp/build_b3366ff3/pages/admin/reports/index.vue")
  },
  {
    name: "admin-reports-events",
    path: "/admin/reports/events",
    meta: { ...(eventsScUB_45mAWf_455d_45ByWCeUqCvxfiA8x5Wxyphdf6EZSCjgMeta || {}), ...{"middleware":["is-admin"]} },
    component: () => import("/tmp/build_b3366ff3/pages/admin/reports/events.vue")
  },
  {
    name: "app-auth-preferences",
    path: "/app/auth/preferences",
    meta: preferencesFcR1gTVYJ3RtVo9jEXTCH5EOsA4YcHrl20_45ePoqglOUMeta || {},
    component: () => import("/tmp/build_b3366ff3/pages/app/auth/preferences.vue")
  },
  {
    name: "backstage-auth-login",
    path: "/backstage/auth/login",
    meta: loginkvvrYWAq4s9wPX_kKu7IPBeraWFQWo4v48nr0DmPyAQMeta || {},
    component: () => import("/tmp/build_b3366ff3/pages/backstage/auth/login.vue")
  },
  {
    name: "app-conversation-id",
    path: "/app/conversation/:id()",
    meta: { ...(_91id_93S5PZ28vp6PBabarKWTiA99Q4dZAFcu4L_45z1sXhYKHWEMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_b3366ff3/pages/app/conversation/[id].vue")
  },
  {
    name: "backstage-auth-logout",
    path: "/backstage/auth/logout",
    meta: logoutPd7yidzMUssWzKbZF5RQTGTnEQ5eFFR9ChLP6QEzg5wMeta || {},
    component: () => import("/tmp/build_b3366ff3/pages/backstage/auth/logout.vue")
  },
  {
    name: "main-auth-preferences",
    path: "/main/auth/preferences",
    component: () => import("/tmp/build_b3366ff3/pages/main/auth/preferences.vue")
  },
  {
    name: "app-organizations-list",
    path: "/app/organizations/list",
    meta: { ...(listuSdPbZE6N1ZgDbxDHyKRn5cTFEITceQiafFVMYcXIKAMeta || {}), ...{"middleware":["is-user"]} },
    component: () => import("/tmp/build_b3366ff3/pages/app/organizations/list.vue")
  },
  {
    name: "app-auth-verify-token",
    path: "/app/auth/verify/:token()",
    meta: _91token_9341CvmKqzd2fHSPWdO1U4Jzdrlr148t3YmvZRtJlpQl0Meta || {},
    component: () => import("/tmp/build_b3366ff3/pages/app/auth/verify/[token].vue")
  },
  {
    name: "backstage-auth-register",
    path: "/backstage/auth/register",
    meta: registersGwN3MJr4UyO_wK9uu8zMpWSy_454IaKdF7McaKOOckYMMeta || {},
    component: () => import("/tmp/build_b3366ff3/pages/backstage/auth/register.vue")
  },
  {
    name: "backstage-invite-code",
    path: "/backstage/invite/:code()",
    meta: _91code_93M9_DR2rgZ0gEdLGycALsRvyQaio7_45sNZZ_45p0IXKe0okMeta || {},
    component: () => import("/tmp/build_b3366ff3/pages/backstage/invite/[code].vue")
  },
  {
    name: "app-integrations-discord",
    path: "/app/integrations/discord",
    meta: discordnJaXDftbSlmj96oIfi_xlqLSMvSMrASzRBVcmSlmZBAMeta || {},
    component: () => import("/tmp/build_b3366ff3/pages/app/integrations/discord.vue")
  },
  {
    name: "backstage-dashboard",
    path: "/backstage/dashboard",
    meta: { ...(indexF1hnQWxDdCfk3QR0sUTQxTAZajpzp8i_45_QuJqqkp2dsMeta || {}), ...{"middleware":["backstage-is-user"]} },
    component: () => import("/tmp/build_b3366ff3/pages/backstage/dashboard/index.vue")
  },
  {
    name: "main-questions-frequentes",
    path: "/main/questions-frequentes",
    meta: questions_45frequentesViaFT4mJzwvaYgh4KknABax6citH91yQBtMV3obmt5IMeta || {},
    component: () => import("/tmp/build_b3366ff3/pages/main/questions-frequentes.vue")
  },
  {
    name: "app-integrations-discord-auth",
    path: "/app/integrations/discord-auth",
    meta: discord_45authsc6hN0mr__45Uu8sn01TgH5WMKcqrlrg7vepJmIrIavOwMeta || {},
    component: () => import("/tmp/build_b3366ff3/pages/app/integrations/discord-auth.vue")
  },
  {
    name: "backstage-dashboard-subscribe",
    path: "/backstage/dashboard/subscribe",
    meta: { ...(subscribecWlaoO74hnwhgOJwdkD_45gOgziGUNl1sE3v1MIEAC03MMeta || {}), ...{"middleware":["backstage-is-user"]} },
    component: () => import("/tmp/build_b3366ff3/pages/backstage/dashboard/subscribe.vue")
  },
  {
    name: "backstage-dashboard-events",
    path: "/backstage/dashboard/events",
    meta: { ...(indexhAafVUmOcsftiZf9aRFo_I_45iVw1Alm5kH56pAc6rqIoMeta || {}), ...{"middleware":["backstage-is-user"]} },
    component: () => import("/tmp/build_b3366ff3/pages/backstage/dashboard/events/index.vue")
  },
  {
    name: "backstage-dashboard-places",
    path: "/backstage/dashboard/places",
    meta: { ...(indexq32UjAZLGgBsIV_QGPzSmpFk6fIEoeNg7UbGCkFeHzMMeta || {}), ...{"middleware":["backstage-is-user"]} },
    component: () => import("/tmp/build_b3366ff3/pages/backstage/dashboard/places/index.vue")
  },
  {
    name: _91slug_93vugurFy0nEPl0ZYV0z7WIPZpbmgSXUZzqPy8cgCUbqgMeta?.name,
    path: "/backstage/dashboard/events/:slug()",
    component: () => import("/tmp/build_b3366ff3/pages/backstage/dashboard/events/[slug].vue"),
    children: [
  {
    name: editODH1ysw4pY5yMHYwJL6zlzOjMICMqkAXomz9SilZsMIMeta?.name,
    path: "edit",
    meta: { ...(editODH1ysw4pY5yMHYwJL6zlzOjMICMqkAXomz9SilZsMIMeta || {}), ...{"middleware":["backstage-is-user"]} },
    component: () => import("/tmp/build_b3366ff3/pages/backstage/dashboard/events/[slug]/edit.vue"),
    children: [
  {
    name: "backstage-dashboard-events-slug-edit",
    path: "",
    component: () => import("/tmp/build_b3366ff3/pages/backstage/dashboard/events/[slug]/edit/index.vue")
  },
  {
    name: "backstage-dashboard-events-slug-edit-details",
    path: "details",
    component: () => import("/tmp/build_b3366ff3/pages/backstage/dashboard/events/[slug]/edit/details.vue")
  },
  {
    name: "backstage-dashboard-events-slug-edit-advanced",
    path: "advanced",
    component: () => import("/tmp/build_b3366ff3/pages/backstage/dashboard/events/[slug]/edit/advanced.vue")
  },
  {
    name: "backstage-dashboard-events-slug-edit-attendees",
    path: "attendees",
    component: () => import("/tmp/build_b3366ff3/pages/backstage/dashboard/events/[slug]/edit/attendees.vue")
  }
]
  },
  {
    name: "backstage-dashboard-events-slug",
    path: "",
    meta: { ...(indexMp0kxh5ttS43JhHj0o3VHKjQhV54xkftg6vreudxfUkMeta || {}), ...{"middleware":["backstage-is-user"]} },
    component: () => import("/tmp/build_b3366ff3/pages/backstage/dashboard/events/[slug]/index.vue")
  },
  {
    name: "backstage-dashboard-events-slug-attendees",
    path: "attendees",
    meta: { ...(attendeesKgHLGwdomTTR6wetL9N6Bj9N7u6rPcetJFm_459hp4hccMeta || {}), ...{"middleware":["backstage-is-user"]} },
    component: () => import("/tmp/build_b3366ff3/pages/backstage/dashboard/events/[slug]/attendees.vue")
  }
]
  },
  {
    name: "backstage-dashboard-events-create",
    path: "/backstage/dashboard/events/create",
    meta: { ...(createKs6lsHbZRp2Op25_KfVh18ZXPjg_RVfq5Y6wnz5CHmQMeta || {}), ...{"middleware":["backstage-is-user"]} },
    component: () => import("/tmp/build_b3366ff3/pages/backstage/dashboard/events/create.vue")
  },
  {
    name: "backstage-dashboard-settings",
    path: "/backstage/dashboard/settings",
    meta: { ...(index9tZFPNLC4EhlZmlFX16zpI02CjSPibNBC0QUlyUF_3AMeta || {}), ...{"middleware":["backstage-is-user"]} },
    component: () => import("/tmp/build_b3366ff3/pages/backstage/dashboard/settings/index.vue")
  },
  {
    name: "backstage-dashboard-organization",
    path: "/backstage/dashboard/organization",
    meta: { ...(indexSU6XSJfd78Ksr6xB1SQTykEpLSk5iXjA25s3KJc06W8Meta || {}), ...{"middleware":["backstage-is-user"]} },
    component: () => import("/tmp/build_b3366ff3/pages/backstage/dashboard/organization/index.vue")
  },
  {
    name: component_45stuba1_45WExzWfl1cUO3EeNQED72AZGAhTHwpALY2wQtUwTYMeta?.name,
    path: "/sitemap.xml",
    component: component_45stuba1_45WExzWfl1cUO3EeNQED72AZGAhTHwpALY2wQtUwTY
  }
]